/*!

=========================================================
* Argon Dashboard React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useEffect, Suspense } from "react";
import {
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

import Sidebar from "components/Sidebar/Sidebar";
import HeaderContainer from "components/Headers/HeaderContainer";
import ThinHeader from "components/Headers/ThinHeader";
import Loader from "components/Loader";
import { isFeatureEnabled } from "@redux/selectors";

import routes from "routes";
import keys from "configs/constants";

const Admin = (props) => {
  const location = useLocation();

  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [location]);

  const isMaintenancePageEnabled = useSelector(isFeatureEnabled("PrivilegedUsers"));

  const getRoutes = (routes) =>
    routes.map((prop, key) => {
      if (prop.layout === "/ad") {
        if (prop.featureFlag === "PrivilegedUsers" && !isMaintenancePageEnabled) return null;
        const Comp = prop.component;
        return <Route path={prop.path} element={<Comp />} key={key} />;
      }
      return null;
    });

  const getBrandText = () => {
    for (const element of routes) {
      if (location.pathname.includes(element.layout + element.path)) {
        return element.name;
      }
    }
    return "brand";
  };

  return (
    <>
      <Sidebar
        {...props}
        routes={routes}
        logo={{
          imgAlt: "Logo",
          imgSrc: keys.LOGO_URL,
          innerLink: "/std/index",
        }}
        onlyAdmin={true}
      />
      <div className="main-content">
        <HeaderContainer>
          <ThinHeader {...props} brandText={getBrandText()} />
        </HeaderContainer>
        <Suspense fallback={<Loader />}>
          <Routes>
            {getRoutes(routes)}
            <Route path="*" element={<Navigate to="/ad" replace />} />
          </Routes>
        </Suspense>
      </div>
    </>
  );
};

export default Admin;

Admin.propTypes = {
  routes: PropTypes.array,
  auth: PropTypes.object,
  onSignOut: PropTypes.func,
  t: PropTypes.func,
};
